import {alertAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/react'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(alertAnatomy.keys)
const baseStyle = definePartsStyle({
  container: {
    borderRadius: '0.25rem',
  },
  icon: {height: '1.25rem'},
  title: {
    fontSize: '1.125rem',
  },
})

const sm = defineStyle({
  fontSize: '1rem',
})

const smIcon = defineStyle({
  height: '1rem',
})

const sizes = {
  sm: definePartsStyle({title: sm, description: sm, icon: smIcon}),
}

const successNoBorder = definePartsStyle({
  container: {
    bg: 'sg5',
  },
  icon: {
    color: '#38A169',
  },
})
const success = definePartsStyle({
  container: {
    bg: 'sg5',
    borderLeft: '4px',
    borderColor: 'sg50',
  },
  icon: {
    color: '#38A169',
  },
})

const errorNoBorder = definePartsStyle({
  container: {
    bg: 'sr5',
  },
  icon: {
    color: 'sr60',
  },
})
const error = definePartsStyle({
  container: {
    bg: 'sr5',
    borderLeft: '4px',
    borderColor: 'sr60',
  },
  icon: {
    color: 'sr60',
  },
})
const infoNoBorder = definePartsStyle({
  container: {
    bg: 'pb5',
  },
  icon: {
    color: 'pb60',
  },
})
const info = definePartsStyle({
  container: {
    bg: 'pb5',
    borderLeft: '4px',
    borderColor: 'pb60',
  },
  icon: {
    color: 'pb60',
  },
})
const warningNoBorder = definePartsStyle({
  container: {
    bg: '#FFF4E7',
  },
  icon: {
    color: 'so60',
  },
})
const warning = definePartsStyle({
  container: {
    bg: '#FFF4E7',
    borderLeft: '4px',
    borderColor: 'so60',
  },
  icon: {
    color: 'so60',
  },
})

export const AlertStyles = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {
    successNoBorder,
    success,
    errorNoBorder,
    error,
    infoNoBorder,
    info,
    warningNoBorder,
    warning,
  },
})
